import { render, staticRenderFns } from "./StudentProfileMarks.vue?vue&type=template&id=a18a44be&scoped=true&"
import script from "./StudentProfileMarks.vue?vue&type=script&lang=js&"
export * from "./StudentProfileMarks.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileMarks.vue?vue&type=style&index=0&id=a18a44be&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a18a44be",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VCardTitle,VContainer})
